import React, { useState } from 'react';
import NewConnectionDialogStart from './NewConnectionDialogStart';
import NewConnectionDialogShareMyTeamsData from './NewConnectionDialogShareMyTeamsData';
import NewConnectionDialogRequestAccess from './NewConnectionDialogRequestAccess';
import NewConnectionDialogComplete from './NewConnectionDialogComplete';
import { TeamConnectionGq } from '../../../graphql/users/models/TeamConnectionGq';
import { CurrentTeamGq } from '../../../graphql/users/models/CurrentTeamGq';

export interface NewConnectionDialogProps {
  close: () => void;
  reload: () => Promise<unknown>;
  connections: TeamConnectionGq[];
  team: CurrentTeamGq;
}

export enum ConnectionStep {
  Start,
  ShareMyTeamsData,
  RequestOtherTeamsData,
  Complete,
}
export const NewConnectionDialog: React.FC<NewConnectionDialogProps> = ({
  close,
  reload,
  connections,
  team,
}) => {
  const [step, setStep] = useState<ConnectionStep>(ConnectionStep.Start);
  const minDialogWidth = 'min-w-[500px]';

  const handleClose = () => {
    setStep(ConnectionStep.Start);
    close();
  };

  if (step === ConnectionStep.Start)
    return (
      <NewConnectionDialogStart
        close={handleClose}
        shareTeamData={() => setStep(ConnectionStep.ShareMyTeamsData)}
        requestAccessToTeamData={() => setStep(ConnectionStep.RequestOtherTeamsData)}
        team={team}
        minWidth={minDialogWidth}
      />
    );

  if (step === ConnectionStep.ShareMyTeamsData)
    return (
      <NewConnectionDialogShareMyTeamsData
        close={handleClose}
        back={() => setStep(ConnectionStep.Start)}
        onSuccess={() => reload().then(() => setStep(ConnectionStep.Complete))}
        minWidth={minDialogWidth}
      />
    );

  if (step === ConnectionStep.RequestOtherTeamsData)
    return (
      <NewConnectionDialogRequestAccess
        close={handleClose}
        back={() => setStep(ConnectionStep.Start)}
        onSuccess={() => reload().then(() => setStep(ConnectionStep.Complete))}
        connections={connections}
        team={team}
        minWidth={minDialogWidth}
      />
    );

  if (step === ConnectionStep.Complete)
    return <NewConnectionDialogComplete close={handleClose} minWidth={minDialogWidth} />;

  return null;
};

export default NewConnectionDialog;
